import { useAppContext } from '../../appProvider/contextProvider';
import getSymbolFromCurrency from 'currency-symbol-map';
import roundOff from '../../Util/roundOff';


const Amount = ({amount}) => {
    const {selectedWebsite} = useAppContext();

    return <>{selectedWebsite?.currency ? `${getSymbolFromCurrency(selectedWebsite?.currency)}` : '$'} {roundOff(Number(amount))}</>
}

export default Amount;